
export class Constant {
    public static readonly correspondanceServiceApiBaseUrl: string = 'correspondanceServiceApiBaseUrl';
    public static readonly memberManagerApiBaseUrl: string = 'memberManagerApiBaseUrl';
    public static readonly templateServiceApiBaseUrl: string = 'templateServiceApiBaseUrl';
    public static readonly notificationProcessorApiBaseUrl: string = 'notificationProcessorApiBaseUrl';


    public static readonly EmailUnSubscribeSuccessTemplateId: string ='EmailUnSubscribeSuccess.TemplateId';
    public static readonly EmailSubscribeSuccessTemplateId: string ='EmailSubscribeSuccess.TemplateId';
}

